import React from 'react'

import { SVGComponent } from '../..'

const LinkAccountsSuccess = () => {
  return (
    <div
      className="bg-white br-4 br-4 o-hidden d-flex flex-column flex-center"
      style={{
        width: '400px',
        height: '468px'
      }}
    >
      <div className="d-flex flex-column flex-middle">
        <div className="mb-3">
          <SVGComponent svgIcon="group" />
        </div>
        <div className="fs-3 fw-600 c-success-500">
          Accounts linked successfully
        </div>
      </div>
    </div>
  )
}

export default LinkAccountsSuccess
